// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "b46cfbee7a3ca0530357c0f8b775ae3d9b7b8ea5/scripts/" + chunkId + ".js";
};